<template>
    <template v-for="price in list">
        <div v-if="price.price > 0" :class="{'unavailable-price': !price.available}">
            <humanized-money :value="price.price"></humanized-money>
            <span class="price-type">({{ price.name }})</span>
        </div>
    </template>
</template>
<style scoped>
    .unavailable-price {
        opacity: .3;
    }

    .price-type {
        font-size: 12px;
        color: #999;
    }
</style>
<script>
    const R = require('ramda')

    export default {
        name: 'property-stacked-prices',
        props: {
            property: {
                required: true
            }
        },
        computed: {
            list () {
                return R.pipe(
                    R.sortBy((x) => x.available),
                    R.reverse
                )([
                    { name: 'venda', price: this.property.sell_price, available: this.property.for_sale },
                    { name: 'locação', price: this.property.rent_price, available: this.property.for_rent },
                    { name: 'temporada', price: this.property.vacation_price, available: this.property.for_vacation },
                    { name: 'arrendamento', price: this.property.lease_price, available: this.property.for_lease }
                ])
            }
        }
    }
</script>


// WEBPACK FOOTER //
// StackedPrices.vue?32bc5460